module.exports = __webpack_public_path__ + "img/classic2.e20f9531.png";